import { useProductRefreshPreviewContext } from './productRefreshPreviewContext'
import { useProductRefreshAlphaEnabled } from './useProductRefreshAlphaEnabled'
import { useProductRefreshGlobalBetaEnabled } from './useProductRefreshGlobalBetaEnabled'
import { useProductRefreshGlobalOptInDisabled } from './useProductRefreshGlobalOptInDisabled'
import { useProductRefreshUserOptIn } from './useProductRefreshUserOptIn'

/**
 * True when the user may experience product refresh UI (shell, theme, settings IA).
 *
 * - **Beta** (`ap_product_refresh_2026_global`): opt-in via `user_settings`, or forced when
 *   `ap_product_refresh_2026_global_opt_in_disabled` is on. No dev-preview bypass.
 * - **Alpha** (any `ap_rebrand_*` flag): same opt-in rules, plus internal preview toggle
 *   (`ProductRefreshPreviewToggle`) when the user is in the alpha cohort.
 */
export function useProductRefreshBetaGate(): boolean {
  const hasGlobalBeta = useProductRefreshGlobalBetaEnabled()
  const optInDisabled = useProductRefreshGlobalOptInDisabled()
  const userOptedIn = useProductRefreshUserOptIn()
  const isAlpha = useProductRefreshAlphaEnabled()
  const { override } = useProductRefreshPreviewContext()
  const devPreviewOverride = isAlpha && override === true

  if (hasGlobalBeta) {
    if (optInDisabled) {
      return true
    }
    return userOptedIn
  }

  return userOptedIn || devPreviewOverride
}
